import { graphql } from "gql";

const USER_ATTRIBUTE_LIST_QUERY = graphql(`
  query UserAttributeList {
    userAttributeList {
      ...UserAttribute
    }
    userAttributeCategoryList {
      ...UserAttributeCategory
    }
  }
`);

export default USER_ATTRIBUTE_LIST_QUERY;
